import { ChangeDetectionStrategy, Component, DestroyRef, Inject, OnInit, Signal, viewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../../../store/app.state';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { Actions, ofType } from '@ngrx/effects';
import { UiKitModule } from 'src/app/shared/ui-kit/ui-kit.module';
import { DatabaseTagsModel } from '@models/database-tags.model';
import { DatabaseTagsActions } from '@states/database-tags/database-tags.action.types';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DatabaseTagsSelectors } from '@states/database-tags/database-tags.selector-types';
import { FormComponent } from '../../components/form/form.component';
import { TranslatePipe } from '@ngx-translate/core';
import { EnableEscCloseDirective } from 'src/app/shared/directives/enable-esc-close.directive';
import { UiButtonComponent } from '@ui';

export interface EditTagDialogData {
  id: string;
  name: string;
  color?: string;
  isShownInLeftPanel?: boolean;
}

@Component({
  selector: 'app-edit-tag-dialog',
  imports: [
    UiKitModule,
    MatDialogClose,
    FormComponent,
    TranslatePipe,
    UiButtonComponent,
  ],
  templateUrl: './edit-tag-dialog.component.html',
  styleUrl: './edit-tag-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [EnableEscCloseDirective],
})
export class EditTagDialogComponent implements OnInit {
  public selectIsSaving: Signal<boolean> = this.store$.selectSignal(DatabaseTagsSelectors.selectIsSaving);

  public formComponent = viewChild(FormComponent);

  constructor(
    private store$: Store<AppState>,
    private matDialogRef: MatDialogRef<EditTagDialogComponent>,
    private actions$: Actions,
    private destroyRef: DestroyRef,
    @Inject(MAT_DIALOG_DATA) public data: EditTagDialogData,
  ) { }

  public ngOnInit() {
    this.actions$
      .pipe(ofType(DatabaseTagsActions.editDatabaseTagSuccess), takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.close());
  }

  public save(): void {
    const dto = {
      ...this.formComponent().form.value,
    } as Partial<DatabaseTagsModel.DatabaseTagCreateDto>;

    this.store$.dispatch(DatabaseTagsActions.editDatabaseTag({ id: this.data?.id, dto: { ...dto } }));
  }

  public close(): void {
    this.matDialogRef.close();
  }
}
